<div class="main">
  <app-page-greeting />
  <div class="right-hlf">
    <div class="right-hlf-header page-loader-steps"></div>
    <div class="content page-loader-content">
      <div class="page-loader-card ds-bg-white ds-rounding-large">
        <citadel-loader [showing]="true" role="status" aria-label="Loading" />
      </div>
    </div>
  </div>
</div>
